/**
 * Ensure a start slash on any string you pass
 * @example
 * ```
 * ensureStartSlash('path/to'); // '/path/to'
 * ```
 * @param path
 */
export function ensureStartSlash(path: string): string {
    if (path && !path.startsWith('/')) {
        return `/${path}`;
    }

    return path;
}

/**
 * Ensure an end slash on any string you pass
 * @example
 * ```
 * ensureEndSlash('path/to'); // 'path/to/'
 * ```
 * @param path
 */
export function ensureEndSlash(path: string): string {
    if (path && !path.endsWith('/')) {
        return `${path}/`;
    }

    return path;
}

/**
 * Ensure start & end slashes on any string you pass
 * @example
 * ```
 * ensureSlashes('path/to'); // '/path/to/'
 * ```
 * @param path
 */
export function ensureSlashes(path: string): string {
    return ensureStartSlash(ensureEndSlash(path));
}
